<div class="widget">
  <div class="amSuite-widget-header">
    {{'widgets.activity-graphs.typology-graph.title' | translate}}
    @if (modify) {
      <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
        pTooltip="{{'widgets.user-activities.edit' | translate}}">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </a>
    }
    @if (!modify) {
      <small class="date-font"><i>({{ initialDate | dateMoment:shortDate }} -
        {{ finalDate | dateMoment:shortDate }})</i></small>
    }
  </div>
  @if (!modify) {
    <div class="graph-widget amSuite-widget-block">
      @switch (status) {
        @case ('ready') {
          <div class="chart-card-content">
            <p-chart type="bar" [height]="CanvasHeight+'px'" [data]="dataOfTypology" [options]="barOptions"></p-chart>
          </div>
        }
        @case ('busy') {
          <div>
            <p>
              <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
        }
      }
    </div>
  }
</div>
